import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="spoiler-text"
export default class extends Controller {
  connect() {
    // Ensure spoiler is hidden by default (blurred)
    this.hide();
  }

  toggle() {
    if (this.element.classList.contains("spoiler-revealed")) {
      this.hide();
    } else {
      this.reveal();
    }
  }

  reveal() {
    this.element.classList.add("spoiler-revealed");
    this.element.classList.remove(
      "blur-sm",
      "bg-gray-600",
      "bg-opacity-50",
      "hover:bg-opacity-70"
    );
    this.element.classList.add("bg-transparent");
  }

  hide() {
    this.element.classList.remove("spoiler-revealed", "bg-transparent");
    this.element.classList.add(
      "blur-sm",
      "bg-gray-600",
      "bg-opacity-50",
      "hover:bg-opacity-70"
    );
  }

  showTooltip() {
    if (this.tooltipElement) return; // Don't create multiple tooltips

    // Get element position
    const rect = this.element.getBoundingClientRect();

    this.tooltipElement = document.createElement("div");
    this.tooltipElement.textContent = this.element.classList.contains(
      "spoiler-revealed"
    )
      ? "Click to hide spoiler"
      : "Click to view spoiler";
    this.tooltipElement.className =
      "fixed z-50 px-2 py-1 text-xs text-white bg-black bg-opacity-90 rounded whitespace-nowrap pointer-events-none";
    this.tooltipElement.style.left = `${rect.left + rect.width / 2}px`;
    this.tooltipElement.style.top = `${rect.top - 32}px`;
    this.tooltipElement.style.transform = "translateX(-50%)";

    // Append to body instead of the blurred element
    document.body.appendChild(this.tooltipElement);
  }

  hideTooltip() {
    if (this.tooltipElement) {
      this.tooltipElement.remove();
      this.tooltipElement = null;
    }
  }

  disconnect() {
    this.hideTooltip();
  }
}
